import { CSSProperties, ReactNode } from 'react';
import { useReduxState } from 'hooks';

interface Props {
  children: ReactNode;
  contentHeight: number;
  contentStyle?: CSSProperties;
  headerHeight: number;
  subHeaderHeight: number;
  title: string;
  useLoginBackground?: boolean;
}

const SettingsPictureScreen = ({
  children,
  contentHeight,
  contentStyle,
  headerHeight,
  subHeaderHeight,
  title,
  useLoginBackground
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="wrapper">
      <div className="title">{title}</div>
      <div className="screen">
        <div className="app">
          <div className="header" style={{ height: headerHeight }} />
          <div className="subheader" style={{ height: subHeaderHeight }} />
          <div
            className="content"
            style={{ height: contentHeight, ...contentStyle }}
          >
            {children}
          </div>
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          position: relative;
        }
        .title {
          color: ${theme.textColorLight};
          font-size: 1.4rem;
          font-weight: 600;
          position: absolute;
          text-align: center;
          top: 3px;
          width: 100%;
          z-index: 1;
        }
        .screen {
          background-color: ${theme.lightGreyDark};
          border: 6px solid ${theme.lightGreyDark};
          border-radius: ${theme.cardBorderRadius};
          border-top-width: 25px;
          overflow: hidden;
          position: relative;
          width: 100%;
        }
        .app {
          background-color: ${useLoginBackground && theme.loginBackgroundColor
            ? theme.loginBackgroundColor
            : theme.pageBackgroundColor};
          border-radius: 0 0 ${theme.buttonBorderRadius}
            ${theme.buttonBorderRadius};
          position: relative;
        }
        .header {
          background-color: white;
        }
        .subheader {
          background-color: ${theme.subHeaderBackgroundColor};
        }
      `}</style>
    </div>
  );
};

export default SettingsPictureScreen;
